import { render, staticRenderFns } from "./News.vue?vue&type=template&id=08363bc8&scoped=true&"
import script from "./News.vue?vue&type=script&lang=ts&"
export * from "./News.vue?vue&type=script&lang=ts&"
import style0 from "./News.vue?vue&type=style&index=0&id=08363bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08363bc8",
  null
  
)

export default component.exports